import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import React from "react";
import { SVGIcon } from "./SVGIcon";
// NOTE: This needs to stay a function component otherwise downstream icon tooling will not be able
// to find icon nodes via ts-morph since it expects a function node. (We can't switch to variable node)
export function createSVGIcon(path, displayName, defaultProps) {
  var Component = /*#__PURE__*/React.memo(function (_ref) {
    var props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    var _useStrictLocalizatio = useStrictLocalization(),
      strictLocalize = _useStrictLocalizatio.strictLocalize;
    var unwrappedDefaultProps = typeof defaultProps === "function" ? defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps(strictLocalize) : defaultProps;
    var _ref2 = unwrappedDefaultProps !== null && unwrappedDefaultProps !== void 0 ? unwrappedDefaultProps : {},
      defaultClass = _ref2.className,
      titleAccess = _ref2.titleAccess;
    var _ref3 = props !== null && props !== void 0 ? props : {},
      explicitClass = _ref3.className;
    var curriedClass = [defaultClass, explicitClass].filter(function (c) {
      return !!c;
    }).join(" ");
    return /*#__PURE__*/React.createElement(SVGIcon, _objectSpread(_objectSpread(_objectSpread({
      titleAccess: titleAccess
    }, unwrappedDefaultProps), props), {}, {
      className: curriedClass
    }), path);
  });
  if (process.env.NODE_ENV !== "production") {
    Component.displayName = "".concat(displayName, "Icon");
  }
  return Component;
}